/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DayOfWeek = {
    _11184809: '11184809',
    MON: 'MON',
    TUE: 'TUE',
    WED: 'WED',
    THU: 'THU',
    FRI: 'FRI',
    SAT: 'SAT',
    SUN: 'SUN',
    unknown_default_open_api: '11184809'
} as const;
export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


export function instanceOfDayOfWeek(value: any): boolean {
    for (const key in DayOfWeek) {
        if (Object.prototype.hasOwnProperty.call(DayOfWeek, key)) {
            if (DayOfWeek[key as keyof typeof DayOfWeek] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DayOfWeekFromJSON(json: any): DayOfWeek {
    return DayOfWeekFromJSONTyped(json, false);
}

export function DayOfWeekFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayOfWeek {
    return json as DayOfWeek;
}

export function DayOfWeekToJSON(value?: DayOfWeek | null): any {
    return value as any;
}

